import {apiFuns} from "sw-hic"
let {genStandard} = apiFuns
const api = {
  HospitalSeekMedical: genStandard("hospitalSeekMedical", "/api/ip"),
  Hospitalization: genStandard("hospitalization", "/api/ip"),
}
export default api;